import { Response, Success } from 'src/app/sdk/sdk';

import { Injectable } from '@angular/core';
import { UserAccountsRepository } from '../repositories/user-accounts.repository';

@Injectable({
  providedIn: 'root'
})
export class ClearAccountsUseCase {
  constructor(private _userAccountRepository: UserAccountsRepository) {}

  async execute(): Promise<Response<boolean, ClearAccountsError>> {
    const result = await this._userAccountRepository.clearAll();
    return new Success(result.value);
  }
}

export abstract class ClearAccountsError {}
